export const generateSubscriptionCIDKey = ({
  orgId,
  streamId,
  channelId,
  subscriptionId,
}) => `${orgId}/${streamId}/${channelId}/${subscriptionId}`;
